import SpendXForDiscount from './AddPromotion/SpendXForDiscount.vue'
import MultiBuy from './AddPromotion/MultiBuy.vue'
import BuyXForDiscount from './AddPromotion/BuyXForDiscount.vue'
import BuyXGetYOff from './AddPromotion/BuyXGetYOff.vue'

export default {
  name: 'AddPromotionPartialView',

  props: {
    value: Object,
    regionId: Number,
    maxCustomerGroupId: Number,
    shown: Boolean
  },

  data () {
    return {
      loading: false,
      types: [{
        text: 'Spend $x and get y (PLU) Free or reduced price',
        value: 'SPEND_X_FOR_DISCOUNT'
      }, {
        text: 'Multi-buy',
        value: 'MULTI_BUY'
      }, {
        text: 'Buy x (PLU) and get y (PLU) reduced or Free',
        value: 'BUY_X_FOR_DISCOUNT'
      },
      {
        text: 'Buy Item x and get y off',
        value: 'MULTIBUY_X_FOR_DISCOUNT'
      }],
      promotion: null,
      type: null
    }
  },
  components: {
    'spend-x-for-discount': SpendXForDiscount,
    'buy-x-for-discount': BuyXForDiscount,
    'multi-buy': MultiBuy,
    'buy-x-for-y-off': BuyXGetYOff
  },

  methods: {
    change (promotion) {
      promotion.type = this.type
      this.$emit('change', promotion)
      this.hide()
    },

    hide () {
      this.$emit('hide')

      if (!this.type) {
        this.$emit('focus-lost')
      }
    },

    hideType () {
      this.type = null
      this.hide()
    },

    reset () {
      this.$emit('focus-gained')

      if (this.value) {
        this.promotion = this.value
        this.type = this.value.type
      } else {
        this.promotion = null
        this.type = null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/EditEvent/AddPromotion.js